import { HD, FULL_HD } from '@bedrock-rdk/constants';

export const PICTO_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const SHOULD_DISPLAY = true;

export const TEMPLATE = {
  Title: {},
  Description: {},
  Icons: {},
};
